import { defineClassifierEntity, transformClassifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers';
import { classifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
import { defaultCallIntervalData } from './defaults';
export const callIntervalEntityName = 'callInterval';
const callIntervalColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { value: {
        type: 'number-required',
        index: true,
    }, search: {
        type: 'full-text-search-required',
        language: 'english',
    } }));
export function defineCallIntervalClassifier() {
    return defineClassifierEntity({
        entity: {
            version: 1,
            columns: callIntervalColumns,
            onMigrate: (params) => params.oldData,
            onTransformColumns: (context, params) => {
                return Object.assign(Object.assign({}, transformClassifierColumns(params)), { value: params.data.value, search: [params.data.name, params.data.value, params.data.status].join(' ') });
            },
            onAnonymousAuthGet: (appState, response) => response,
            onAnonymousAuthList: (appState, response) => response,
        },
        defaultData: defaultCallIntervalData,
    });
}
